<template>
    <!-- Layout inner -->
    <div class="layout-inner dashboard course_dashboard">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">

          <div class="hd_bar">
            <div class="hd_ic ic-course"></div>
            <div class="hd_txt">
              <v-clamp class="title_txt" autoresize :max-lines="2">{{ course.title }}</v-clamp>
            </div>
          </div>

          <!-- Page content -->
          <div class="container-fluid flex-grow-1 pg_content_container">

            <div class="row">

              <div class="col-sm-12 col-xl-12 pg_sec sec_course_info">
                <t-o-c :uuid="uuid" :entityUuid="entityUuid"></t-o-c>
              </div>

            </div>
          </div>
          <!-- / Page content -->
          <!-- Footer Navbar -->
          <template v-if="continueLearningOptions.length > 0">
            <course-footer-navbar :uuid="course.uuid" :entityUuid="continueLearningOptions[0].uuid" :isCourseFinished="isCourseFinished"></course-footer-navbar>
          </template>
          <template v-else>
            <course-footer-navbar :uuid="uuid" :isCourseFinished="isCourseFinished"></course-footer-navbar>
          </template>
          <!-- / Footer Navbar -->
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import SecondaryNavbar from '../../misc/components/./SecondaryNavbar'
import CourseFooterNavbar from '../../misc/components/./CourseFooterNavbar'
import TOC from './TOC'
import VClamp from 'vue-clamp'

export default {
  name: 'courseTOC',
  props: ['uuid', 'entityUuid'],
  components: {
    Navbar,
    SecondaryNavbar,
    CourseFooterNavbar,
    VClamp,
    TOC
  },
  data: () => {
    return {
      course: {},
      competencySummary: {},
      continueLearningOptions: [],
      idealPaceVal: '',
      classPaceVal: '',
      userPaceVal: '',
      pace: {}
    }
  },

  mounted () {
    this.loadCourseInfo()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadContinueLearningLast',
      'loadClassSummaryWithPeer',
      'loadCompetencyProgress',
      'loadUserObj'
    ]),
    async loadCourseInfo () {
      this.course = await this.loadCourseDetail(this.uuid)
      this.continueLearningOptions = await this.loadContinueLearningLast(this.uuid)
      await this.loadUserObj()
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    }),
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    major () {
      if (this.userObj) {
        return this.userObj.major1Title
      } else {
        return ''
      }
    },
    majorGPA () {
      if (this.userObj) {
        return this.userObj.majorGpa
      } else {
        return '0.0'
      }
    },
    overallGPA () {
      if (this.userObj) {
        return this.userObj.overallGpa
      } else {
        return '0.0'
      }
    },
    isCourseFinished () {
      let isFinished = true
      if (this.continueLearningOptions.length > 0 && (this.continueLearningOptions[0].title !== 'COURSE_FINISHED')) {
        isFinished = false
      }
      return isFinished
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/CourseTOC.vue